
let websocketURL = ''; let websocketPushURL = ''; let baseImgUrl = ''; let baseUrl = ''
if (window.location.protocol === 'http:') {
  if (window.location.hostname === 'localhost' || window.location.hostname === '192.168.1.101') {
    websocketURL = 'ws://127.0.0.1:6789/dj-prod-api/api/v1/ws'// 测试
    baseImgUrl = 'http://127.0.0.1:6789/dj-cloud-bucket/'// 测试
    baseUrl = '/dj-prod-api/'
  } else {
    baseImgUrl = '/dj-cloud-bucket/'
    websocketURL = `ws://${window.location.host}/dj-prod-api/api/v1/ws`
    websocketPushURL = `ws://${window.location.host}/prod-api/perception/9527`
    baseUrl = `http://${window.location.host}/dj-prod-api/`
  }
} else {
  baseImgUrl = '/dj-cloud-bucket/'
  websocketURL = `wss://${window.location.host}/dj-prod-api/api/v1/ws`
  websocketPushURL = `wss://${window.location.host}/prod-api/perception/9527`
  baseUrl = `https://${window.location.host}/dj-prod-api/`
}
export const CURRENT_CONFIG = {
  title: '低空数联AI智慧巡查平台',
  // title: '',
  // license
  appId: '169621', // You need to go to the development website to apply.
  appKey: '102dc78056ff3d35e6d3af2c17bc6aa', // You need to go to the development website to apply.
  appLicense: 'F80OV/14U42fWUsG9OV8ZKoPQw8Pc9a6WZbzYnh2pFmM7yRWc+LmdvEsJ9j89grNApYcFBldJHA2+LtpLFHoBUmWqgAIaXTMt0Z1amnL6woBK4x5JGDo0++EyYUdhMZ9tLWNdl2Pvzp8N1PfNQ2jLYM/eT2dIKnSggyqgXzoqQY=', // You need to go to the development website to apply.
  // cesium的token ,可以去https://ion.cesium.com/signup/ 申请
  cesiumToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4YTkxNWJjZS0wZDY2LTQ4NjEtYmE4NS1jNGJiMTk3ZjFlM2EiLCJpZCI6NDM4NzcxLCJpc3MiOiJodHRwczovL2FwaS5jZXNpdW0uY29tIiwiYXVkIjoidW5kZWZpbmVkX2RlZmF1bHQiLCJpYXQiOjE3ODAyNzk3MzB9.1QLSIH550wU6FdcjLg4RX8hPTAib24MOQDIX3SdCYt8',

  // http
  baseURL: baseUrl, // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: websocketURL, // Example: 'ws://192.168.1.101:6789/api/v1/ws'
  websocketDeepseekURL: 'ws://127.0.0.1:8900/api/ws/chat/',
  MINGCS_URL: 'http://119.45.238.218/dockgcs/',
  // livestreaming
  rtmpURL: 'rtmp://127.0.0.1:11935/test/live?sign=41db35390ddad33f83944f44b8b75ded', // Example: 'rtmp://192.168.1.101/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'afc0c5d0392f267f72c88f0a25e39b27',
  securityJsCode: '6f3729a40c34c0ce1c8453cada147f65',
  videoQualityValue: 4, // 默认超清；0-自适应，1-流畅，2-标准，3-高清，4-超清

  customerNo: 'Bu1zO4pc', // 算法客户编号
  geoJson: 'geojson/mimou.geojson', // 乡镇边界
  mapCenter: [103.76805, 30.754004], // 地图中心点
  liveUrlObj: {
    dock: 'rtmp://127.0.0.1:19350/rlive/stream_1873?sign=iEVr6lry',
    drone: 'rtmp://127.0.0.1:19350/rlive/stream_1874?sign=YFdJp5Cr',
    droneFpv: ''
  }, // 直播地址
  cameraObj: {
    dock: '165-0-7',
    drone: '81-0-0',
    droneFpv: ''
  }, // 摄像头编号
  imgUrl: baseImgUrl, // 图片地址
  dronePlayer: 'http://127.0.0.1:9685/flv/live/stream_1874.flv', // 无人机播放地址
  target_height: 660, // 海拔

}
